import { Extension } from "@tiptap/core";
import { ReactRenderer } from "@tiptap/react";
import Suggestion from "@tiptap/suggestion";
import { PluginKey } from "prosemirror-state";
import tippy from "tippy.js";
import { getPortalTarget } from "@circle-react-shared/uikit/TipTap/utilities/getPortalTarget";
import { EmojiPicker } from "./EmojiPicker";

export const InlineEmojiExtension = Extension.create({
  addOptions() {
    return {
      portalTargetId: null,
    };
  },
  addProseMirrorPlugins() {
    const appendTarget = getPortalTarget(this.options.portalTargetId);
    return [
      Suggestion({
        editor: this.editor,
        char: ":",
        pluginKey: new PluginKey("emoji"),
        render: () => {
          let reactRenderer: any;
          let popup: any;

          return {
            onStart: props => {
              reactRenderer = new ReactRenderer(EmojiPicker, {
                props,
                editor: props.editor,
              });

              const getReferenceClientRect = () =>
                props.clientRect?.() || new DOMRect(0, 0, 0, 0);

              popup = tippy(appendTarget, {
                getReferenceClientRect,
                content: reactRenderer.element,
                appendTo: () => appendTarget || document.body,
                showOnCreate: true,
                interactive: true,
                trigger: "manual",
                placement: "auto-end",
                theme: "light-border",
              });
            },

            onUpdate(props) {
              reactRenderer.updateProps(props);

              popup[0]?.setProps({
                getReferenceClientRect: props.clientRect,
              });
            },

            onKeyDown(props) {
              if (props.event.key === "Escape") {
                popup[0].hide();

                return true;
              }

              return reactRenderer.ref?.onKeyDown(props);
            },

            onExit() {
              popup[0]?.destroy();
              reactRenderer?.destroy();
            },
          };
        },
      }),
    ];
  },
});
